import Selective from "./Selective";
import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";
import Additive from "./Additive";
import Image from "./Image";
import Category from "./Category";
import Discount from "./Discount";

export type OrderTypes = "table" | "takeaway" | "outside";

@usingJsonToModelConvertor
export class Variant extends Model {

    @fromJsonObject({key: "id"})
    public id!: number;

    @fromJsonObject({key: "variant_of_id"})
    public variantOfId!: number;

    @fromJsonObject({key: "name"})
    public name!: string;

    @fromJsonObject({key: "price"})
    public price!: number;

    @fromJsonObject({key: "stock"})
    public stock!: number;

    @fromJsonObject({key: "is_hidden", modelClass: Boolean})
    public isHidden!: boolean;

    @fromJsonObject({key: "price_with_discount"})
    public priceWithDiscount!: number;

    @fromJsonObject({key: "active_discounts", modelClass: Discount, isArray: true})
    public activeDiscounts!: Discount[];

}
